export default "__VITE_ASSET__DoMahJSp__"